<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="products mainwrap">
      <div class="container">
        <!-- <div class="titleA"><strong>{{ pageContent.title }}</strong></div> -->
        <div class="procat">
          <ul class="catli">
            <li v-for="(x, index) in procat" :key="index" :class="{ 'active-category': selectedProduct.id === x.id }"
              @click="choosethispro(x.id)">
              {{ x.name }}
            </li>
          </ul>
        </div>
        <div class="prolist">
          <div class="pro-itemwrap">
            <div class="pro-item">
              <div v-for="(x, index) in selectedProduct.image" :key="index">
                <el-image class="image" style="width: 100%;  object-fit: cover;" :src="x"
                  :preview-src-list="selectedProduct.image">
                <div slot="placeholder" class="image-slot">
                  <el-skeleton :rows="6" style="width:100%;" animated>
                    <template slot="template">
                      <el-skeleton-item variant="image" style="width: 100%; height: 300px;display:flex;" />
                      <div style="padding: 14px;">
                        <el-skeleton-item variant="p" style="width: 50%" />
                        <el-skeleton-item variant="p" style="width: 70%" />
                        <el-skeleton-item variant="p" style="width: 90%" />
                        <el-skeleton-item variant="p" style="width: 100%" />
                      </div>
                    </template>
                  </el-skeleton>
                </div>
                </el-image>
                <!-- <img :src="x" class="image" style="width: 100%;  object-fit: cover;"> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { pageApi, productApi } from '@/api'

export default {
  name: 'Products',
  data() {
    return {
      pageContent: '',
      procat: [],
      products: [],
      currentPage: 1,
      pageSize: 100, // 每页3条记录
      total: 0,
      activeCategory: null,
      filterName: '',
      selectedProduct: '' // 当前选中的产品
    }
  },
  created() {
    // 从URL查询参数中获取分类ID
    const proid = this.$route.query.proid ? parseInt(this.$route.query.proid) : null;

    this.fetchAboutPage(6)
    this.getprolist(proid)

    // 如果URL中有proid参数，则加载对应分类的产品
    // if (proid) {
    //   this.fetchProducts(proid)
    // }
  },
  methods: {
    onImageLoad() {
      this.showimg = true
    },

    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    },
    async getprolist(e) {
      try {
        const params = {
          page: this.currentPage,
          pagesize: this.pageSize
        }
        const response = await productApi.getProductList(params)
        // 直接使用响应数据，因为request.js已经处理了错误情况
        this.procat = response.data.list
        if (e) {
          this.fetchProducts(e)
        } else {
          this.fetchProducts(this.procat[0].id)
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    async fetchProducts(e) {
      let proid = Number(e)
      try {
        const response = await productApi.getProductById({ id: proid })
        // 直接使用响应数据，因为request.js已经处理了错误情况
        this.selectedProduct = response.data
        this.selectedProduct.image = response.data.image.split(',')
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    choosethispro(e) {
      this.fetchProducts(e)
      // 将分类ID添加到URL参数中
      this.$router.push({ path: this.$route.path, query: { proid: e } })
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;

  .subbanner {
    background-size: 100% 100%;
  }

}

.products {
  padding: 30px 0;

  .container {

    .procat {
      width: 100%;

      ul {
        margin: 0;
        padding: 0;
      }

      ul li {
        display: inline-block;
        list-style: none;
        margin: 0 20px 0 0;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 12px;
        background: #eee;
        cursor: pointer;
        font-weight: normal;
      }

      ul li:hover {
        color: #D32442;
      }

      ul li.active-category {
        background: #D32442;
        color: #ffff;
        font-weight: bold;
      }

      ul li:last-child {
        border: none;
      }
    }

    .prolist {
      width: 100%;
      border: 1px solid #eee;
      margin: 20px 0;

      .nodata {
        border-radius: 6px;
        background: #fff;
        margin: 0 -10px;
        text-align: center;
        padding: 40px;
        color: #909399;
      }

      .pro-itemwrap {
        background: #fff;
        border-radius: 6px;

        .pro-item {
          cursor: pointer;
          display: inline-block;
          width: 100%;

          div {
            width: 50%;
            display: inline-block
          }

          .image-slot {
            width: 100%;
          }

          img {
            border-radius: 6px;
            width: 100%;
          }
        }
      }
    }
  }
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.product-description {
  margin: 10px 0;
  color: #606266;
  line-height: 1.5;
  min-height: 60px;
}

.product-price {
  font-weight: bold;
  color: #E6A23C;
  margin: 10px 0;
  font-size: 16px;
}

.product-detail-content {
  .product-image {
    margin-bottom: 20px;
  }

  .product-info {
    >div {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;
      white-space: pre;
    }

    label {
      font-weight: bold;
      display: inline-block;
      width: 80px;
      margin-bottom: 5px;
    }

    span,
    div {
      display: block;
      color: #333;
    }
  }

}

.product-detail-dialog {
  .el-dialog__header {
    background-color: #f5f7fa;
    padding: 10px 20px;
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    font-size: 1rem;
    line-height: 1.6;
    
    .subbanner {
      
      .container {
        padding-left: 1rem !important;
      }
      
      .title {
        font-size: 1.5rem !important;
        margin: 0.5rem 0 !important;
      }
      
      span {
        font-size: 1rem !important;
      }
    }
  }
  
  .products {
    padding: 1.5rem 0;
    
    .container {
      padding: 0 1rem;
    }
    
    .procat {
      ul {
        padding: 0.5rem;
        
        li {
          display: block !important;
          margin: 0 0 0.5rem 0 !important;
          padding: 0.8rem !important;
          
          &:last-child {
            margin: 0 !important;
          }
        }
      }
    }
    
    .prolist {
      margin: 1rem 0 !important;
      
      .pro-item {
        div {
          width: 100% !important;
          display: block !important;
          margin-bottom: 1rem;
        }
      }
    }
  }
  
  .image {
    width: 100% !important;
  }
  
  .product-description {
    font-size: 0.9rem;
    margin: 0.5rem 0;
  }
  
  .product-price {
    font-size: 1rem;
    margin: 0.5rem 0;
  }
}
</style>